import type { IResource } from "@gettactic/api";

export interface CanQuickReserveParams {
  resource: IResource | null | undefined;
  allowReserve: boolean;
  isLiveMode: boolean;
}

export const canQuickReserve = ({
  resource,
  allowReserve,
  isLiveMode
}: CanQuickReserveParams): boolean => {
  if (!resource || !allowReserve || isLiveMode || resource.is_walkup) {
    return false;
  }
  return resource.type !== "meeting_room";
};
